import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import { Link } from 'react-router-dom';
import Label from 'reactstrap/lib/Label';
import { TR } from 'src/TextRes';
import { BookingOption, CourseListLine, CoursesListAppointmentLine } from '../../api';
import { ISortIcon } from '../../constants';
import FAIcon from '../fAIcon/FAIcon';
import { IThConfig, SortableTh } from '../sortableTh/SortableTh';
import { TableBox } from '../tableBox/TableBox';
import './AdminCoursesTableBox.css';

interface IState {
    showMore: boolean[];
}

export interface TableBoxWithCollapseIconProps<T> {
    listData?: T[];
    renderTHeadLine: IThConfig[];
    headerStyle?: string;
    sortIcon: ISortIcon[];
    collapsed: boolean;
    onClickSorting: (sortField: string, index: number, sortIcon: ISortIcon) => void;
    onClickDisabled: (e: React.SyntheticEvent, str: string) => void;
}

export default class AdminCoursesTableBox extends React.PureComponent<
    TableBoxWithCollapseIconProps<CourseListLine>,
    IState
> {
    constructor(props: TableBoxWithCollapseIconProps<CourseListLine>) {
        super(props);
        this.state = {
            showMore: [],
        };
    }

    public componentDidMount() {
        const showMoreArray: boolean[] = [];
        if (this.props.listData) {
            this.props.listData.map(() => {
                showMoreArray.push(false);
            });
            this.setState({
                showMore: [...showMoreArray],
            });
        }
    }

    public render() {
        if (!this.props.listData) {
            return null;
        }
        const noResultsMessage = TR.adminCoursesTableBox_noResults;

        if (this.props.listData.length < 1) {
            return (
                <legend className="my-3" style={{ color: 'red' }}>
                    {noResultsMessage}
                </legend>
            );
        }

        const renderTHeadLine = (
            <tr className={'courseTableBoxHeader'}>
                {this.props.renderTHeadLine.map((str: IThConfig, index: number) => {
                    return (
                        <SortableTh
                            key={str.name + index}
                            index={index}
                            sortIcon={this.props.sortIcon[index]}
                            sortField={str.sortField}
                            onClickSorting={this.props.onClickSorting}
                            widthStyle={str.width}
                            name={str.name}
                        />
                    );
                })}
            </tr>
        );

        return (
            <TableBox
                listData={this.props.listData}
                renderTBodyLine={this.renderTBody}
                renderTHeadLine={renderTHeadLine}
                headerStyle={this.props.headerStyle}
                bordered={false}
            />
        );
    }

    private renderTBody = (lineData: CourseListLine, index: number) => {
        const translations: Record<string, string> = TR.adminCoursesTableBox_translations;

        const courseRow = (
            <tr className="titleRow">
                <td>{lineData.CourseProviderName}</td>
                <td>{moment(lineData.InsertDate).format('DD.MM.YYYY').toString()}</td>
                <td>
                    {lineData.PublicUrl && (
                        <a href={lineData.PublicUrl} target="_blank">
                            {lineData.Title}
                        </a>
                    )}
                    {!lineData.PublicUrl && lineData.Title}
                    <br />
                    <span>{translations[lineData.Type]}</span>
                </td>
                <td>{lineData.Lecturer}</td>
                <td>
                    {lineData.Published ? (
                        <FAIcon mouseHover={TR.adminCoursesTableBox_published} icon="circle" />
                    ) : (
                        <FAIcon mouseHover={TR.adminCoursesTableBox_draft} icon="circle" className="circleend" />
                    )}
                </td>
                <td>
                    {lineData.Disabled && (
                        <a
                            onClick={(e: React.SyntheticEvent) => {
                                this.props.onClickDisabled(e, 'active');
                            }}
                            data-mail={lineData.Email}
                            data-cid={lineData.CourseID}
                        >
                            <FAIcon mouseHover={TR.adminCoursesTableBox_unblock} icon="ban" className="banned" />
                        </a>
                    )}
                    {!lineData.Disabled && (
                        <a
                            onClick={(e: React.SyntheticEvent) => {
                                this.props.onClickDisabled(e, 'deactive');
                            }}
                            data-mail={lineData.Email}
                            data-cid={lineData.CourseID}
                        >
                            <FAIcon mouseHover={TR.adminCoursesTableBox_block} icon="ban" />
                        </a>
                    )}
                </td>
            </tr>
        );

        let appointments: CoursesListAppointmentLine[] = lineData.Appointments;
        if (this.props.collapsed && appointments) {
            appointments = appointments.filter((a: CoursesListAppointmentLine, i: number) =>
                moment(a.Appointment.StartDate).isAfter(moment())
            );
        }

        if (appointments && appointments.length > 0) {
            appointments.sort((a: CoursesListAppointmentLine, b: CoursesListAppointmentLine) => {
                if (a.Appointment.StartDate < b.Appointment.StartDate) {
                    return -1;
                } else {
                    return 1;
                }
            });
        }

        let detailsRow = null;
        detailsRow = (
            <>
                <tr className="detailsRow">
                    <td colSpan={6}>
                        {appointments && appointments.length > 0 && (
                            <div>
                                {appointments && appointments.length > 1 && (
                                    <a
                                        onClick={() => {
                                            const showMoreN: boolean[] = this.state.showMore;
                                            showMoreN[index] = !showMoreN[index];
                                            this.setState((prevState: IState) => {
                                                return { ...prevState, showMore: [...showMoreN] };
                                            });
                                        }}
                                        className="collapseIcon pull-left"
                                    >
                                        {this.state.showMore[index] ? (
                                            <FAIcon mouseHover={TR.adminCoursesTableBox_showLess} icon="minus-circle" />
                                        ) : (
                                            <FAIcon mouseHover={TR.adminCoursesTableBox_showMore} icon="plus-circle" />
                                        )}
                                    </a>
                                )}
                                &nbsp;&nbsp;
                                <Label>{TR.adminCoursesTableBox_appointments}</Label>
                                {(appointments.length === 1 || this.state.showMore[index]) && (
                                    <table className="admincoursedetailtable mb-2">
                                        <thead>
                                            <tr>
                                                <td>{TR.adminCoursesTableBox_startDate}</td>
                                                <td>{TR.adminCoursesTableBox_endDate}Enddatum</td>
                                                <td>{TR.adminCoursesTableBox_places}</td>
                                                <td style={{ width: '28%' }}>
                                                    {TR.adminCoursesTableBox_booking_request}
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {appointments.map((line: CoursesListAppointmentLine, i) => {
                                                const startDate = moment(line.Appointment.StartDate);
                                                const over = startDate.isBefore(moment());
                                                return (
                                                    <tr key={i} className={over ? 'over' : ''}>
                                                        <td>{startDate.format('DD.MM.YYYY')}</td>
                                                        <td>{moment(line.Appointment.EndDate).format('DD.MM.YYYY')}</td>
                                                        <td>{line.Appointment.MaxParticipants}</td>
                                                        <td>
                                                            {line.Bookings > 0 && (
                                                                <Link
                                                                    to={
                                                                        '/bookings?search=' +
                                                                        encodeURIComponent(lineData.Title)
                                                                    }
                                                                >
                                                                    {line.Bookings}
                                                                </Link>
                                                            )}
                                                            {line.Bookings === 0 && '0'}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        )}
                        <p>
                            {' '}
                            Buchungsoptionen:{' '}
                            {lineData.BookingOptions.map((line: BookingOption, i: number) => {
                                const comma = i === 0 ? '' : ', ';
                                return comma + line.Name + ': ' + line.Price + ' €';
                            })}
                        </p>
                    </td>
                </tr>{' '}
                <tr className="separatorRow">
                    <td colSpan={4}>&nbsp; </td>
                </tr>
            </>
        );

        return (
            <React.Fragment key={index + lineData.CourseID + lineData.Lecturer}>
                {courseRow}
                {detailsRow}
            </React.Fragment>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/adminAllCourses/AdminCoursesTableBox.tsx